import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { DxTabsComponent } from 'devextreme-angular';
import { ActivatedRoute } from '@angular/router';
import { map, shareReplay } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs';
import { AccessType, AuthService, PermissionType } from '@services';
import { EmptyCheckInHistoryComponent } from './empty-check-in-history/empty-check-in-history.component';
import { EmptyCheckInDetailsComponent } from './empty-check-in-details/empty-check-in-details.component';

type TabKey = 'details' | 'history';

@Component({
    selector: 'app-empty-check-in',
    imports: [
        AsyncPipe,
        DxTabsComponent,
        EmptyCheckInDetailsComponent,
        EmptyCheckInHistoryComponent,
    ],
    templateUrl: './empty-check-in.component.html',
})
export class EmptyCheckInComponent {
    private route = inject(ActivatedRoute);
    private auth = inject(AuthService);

    get showDetails(): boolean {
        return this.auth.checkPermission(PermissionType.EmptyCheckInDetails, AccessType.ViewOnly);
    }

    get showHistory(): boolean {
        return this.auth.checkPermission(PermissionType.EmptyCheckInHistory, AccessType.ViewOnly);
    }

    selectedTab: TabKey = this.showDetails ? 'details' : 'history';

    readonly number$ = this.route.paramMap.pipe(
        map((params) => params.get('number')),
        distinctUntilChanged(),
        shareReplay(1),
    );

    allTabs = [
        { key: 'details', text: 'Details', icon: 'fas fa-info-circle', permission: PermissionType.EmptyCheckInDetails },
        { key: 'history', text: 'History', icon: 'fas fa-history', permission: PermissionType.EmptyCheckInHistory },
    ];

    tabs = this.allTabs.filter((t) => this.auth.checkPermission(t.permission, AccessType.ViewOnly));
}
